import React, { useState } from "react";
import styles from "./QuarryMaterialList.module.scss";
import { Collapse } from "antd";
import { CaretRightOutlined } from "@ant-design/icons";
import CustomTableWithPagination from "../../../../reusable-components/CustomTable";
import { deleteFormSchema, subCategoryColumns } from "./constants";
import PhotoViewerModal from "../PhotoViewerModal";
import Form from "../../../Form";
import DeleteMaterialModal from "./DeleteMaterialModal";
import AddMaterialDrawer from "../AddMaterialDrawer";
import ConditionalRender from "../../../../reusable-components/ConditionalRender";
interface QuarryMaterialListProps {
  selectedCategory: string | undefined;
  quarryId: string;
  subCategoryList: [];
  triggerRefetch: (category: string) => void;
}

const QuarryMaterialList = ({
  selectedCategory,
  quarryId,
  subCategoryList = [],
  triggerRefetch,
}: QuarryMaterialListProps) => {
  const { Panel } = Collapse;
  const [selectedId, setSelectedId] = useState<string | undefined>();
  const [isPhotoModalOpen, setIsPhotoModalOpen] = useState<boolean>(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false);
  const [isMaterialEditOpen, setIsMaterialEditOpen] = useState<boolean>(false);
  const [selectedMaterial, setSelectedMaterial] = useState({});
  const handleSetPhotoModalOpen = (id: string) => {
    setSelectedId(id);
    setIsPhotoModalOpen(true);
  };

  const handleSetPhotoModalClose = () => {
    setSelectedId(undefined);
    setIsPhotoModalOpen(false);
  };

  const handleDeleteModalOpen = (id: string) => {
    setSelectedId(id);
    setIsDeleteModalOpen(true);
  };

  const handleDeleteModalClose = () => {
    setSelectedId(undefined);
    setIsDeleteModalOpen(false);
  };

  const handleSetIsEditMaterialOpen = (record: any) => {
    setSelectedMaterial(record);
    setIsMaterialEditOpen(true);
  };
  const handleSetIsEditMaterialClose = (record: any) => {
    setSelectedMaterial({});
    setIsMaterialEditOpen(false);
  };

  return (
    <>
      <Form validationSchema={deleteFormSchema}>
        {() => (
          <DeleteMaterialModal
            isOpen={isDeleteModalOpen}
            handleClose={handleDeleteModalClose}
            submitActionCall={triggerRefetch}
            subCategoryListLength={subCategoryList?.length}
            quarryId={quarryId}
            materialId={selectedId}
          />
        )}
      </Form>
      <ConditionalRender visible={isMaterialEditOpen}>
        <AddMaterialDrawer
          isOpen={isMaterialEditOpen}
          isEdit={true}
          materialDetails={selectedMaterial}
          handleCancel={handleSetIsEditMaterialClose}
          submitActionCall={triggerRefetch}
          quarryId={quarryId}
        />
      </ConditionalRender>
      <PhotoViewerModal
        isOpen={isPhotoModalOpen}
        handleClose={handleSetPhotoModalClose}
        quarryId={quarryId}
        materialId={selectedId}
        key={isPhotoModalOpen}
      />
      <div className={styles.subCategoryList}>
        {subCategoryList?.map((item) => {
          return (
            <Collapse
              expandIcon={({ isActive }) => (
                <CaretRightOutlined
                  style={{ fontSize: "1rem" }}
                  rotate={isActive ? 90 : 0}
                />
              )}
              defaultActiveKey={[item?.key]}
              className={styles.subCategoryCollapse}
              key={item?.key}
            >
              <Panel key={item?.key} header={item?.title}>
                <CustomTableWithPagination
                  data={item?.content}
                  rowKey={"id"}
                  columns={subCategoryColumns({
                    handleSetPhotoModalOpen: handleSetPhotoModalOpen,
                    handleSetDeleteModalOpen: handleDeleteModalOpen,
                    handleSetIsEditMaterialOpen: handleSetIsEditMaterialOpen,
                  })}
                  className={styles.subCategoryTable}
                  pagination={false}
                  bordered={false}
                />
              </Panel>
            </Collapse>
          );
        })}
      </div>
    </>
  );
};

export default QuarryMaterialList;
